export default __webpack_public_path__ + "static/media/gradient-right-dark-next-ui.b130693b.svg";